import React, { useContext } from 'react';
import styled from 'styled-components';
import WordArt from 'react-wordart';
import VideoStream from './VideoStream';
import { displayFlex, flexColumn, width100 } from '../constants';
import Context from '../Context';
import NextButton from './Buttons/NextButton';

const Screen = styled.div`
  ${displayFlex}
  ${flexColumn}
  ${width100}
`;

const VideoPanel = styled.div`
  ${displayFlex}
  ${width100}
  background: black;
`;

export default function VideoCollection() {
  const {
    videoSequences, isLoaded, sequenceIndex, setSequenceIndex,
  } = useContext(Context);

  return (
    <Screen className="screen">
      <VideoPanel classNAme="video-panel">
        {isLoaded && <VideoStream vidIds={videoSequences[sequenceIndex].Sequence} />}
        <NextButton onClick={() => setSequenceIndex(sequenceIndex + 1)} />
      </VideoPanel>

      <WordArt text={videoSequences[sequenceIndex].Initials} theme="radial" fontSize={70} />

    </Screen>
  );
}
